<template>
  <div class="work-edit-redirect">
    <a-spin size="large" />
    <p>{{ message }}</p>
  </div>
</template>

<script>
import { userEditVoteWorks } from "@/api/UserCenter";

export default {
  name: "WorkCompetitionEdit",
  data() {
    return {
      message: "正在跳转到作品修改页...",
    };
  },
  mounted() {
    this.redirectToContestApply();
  },
  methods: {
    async redirectToContestApply() {
      const workId = Number(this.$route.params.id || 0);
      if (!workId) {
        this.message = "未找到作品信息，即将返回个人中心。";
        this.$router.replace({ name: "UserCenter", query: { id: 6 } });
        return;
      }
      try {
        const res = await userEditVoteWorks(workId);
        const detail = res && res.data ? res.data : null;
        if (!detail || !detail.activityId) {
          throw new Error("作品信息不存在");
        }
        this.$router.replace({
          name: "ContestApply",
          params: { contestId: String(detail.activityId) },
          query: {
            mode: "edit",
            workId: String(workId),
          },
        });
      } catch (error) {
        this.message = (error && (error.msg || error.message)) || "作品信息加载失败，即将返回个人中心。";
        this.$message.error(this.message);
        this.$router.replace({ name: "UserCenter", query: { id: 6 } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.work-edit-redirect {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  color: #666;
}
</style>